var Mapcofig = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function Mapcofig() {
    }
    Mapcofig.jscontrol = 'http://10.108.3.16/smi/';
    Mapcofig.jsapi = 'http://10.108.3.16/smiapi/arcgis';
    Mapcofig.jsapiversion4X = '4.15';
    Mapcofig.jsapiversion3X = '3.32';
    return Mapcofig;
}());
export default Mapcofig;
